module.exports = __webpack_public_path__ + "s/img/DSC_6823_4472x4472-2.7beae249.jpg";